import { userStore } from "../gStore/user.store";
import { Game } from "../interfaces/game.interface";
import { userService } from "../services/user.service";
import { GAMES_ENABLED, QA_MODE } from "./url";

export const randomGame = (games: Game[]) => {
  const gameNumber = Math.floor(Math.random() * (games.length));
  const game = games[gameNumber];
  const isGamePlayable = GAMES_ENABLED && (game?.link || game?.staging_link) ? true : false;
  if (isGamePlayable && game) {
    userService.playGame(userStore.data.user.id, game.id);
    const gameURL = QA_MODE && game.staging_link ? game.staging_link : game.link;
    window.location.href = gameURL + `?userId=${userStore.data.user.id}`;
  }
};